import React from 'react'
import styled from 'styled-components'
import { PRIMARY_LIGHT } from '../../styles/colors.style'
import 'react-step-progress-bar/styles.css'
import {
	ProgressBar as ProgressBarComponent,
	Step,
} from 'react-step-progress-bar'
import Browser from '../../services/Browser'

const ProgressBar = ({ nextStep, previousStep, current, items, percent }) => (
	<StyledContainer>
		<ProgressBarComponent filledBackground={PRIMARY_LIGHT} percent={percent}>
			{items.map(({ title }, index) => (
				<Step key={index} transition="scale">
					{({ accomplished }) => (
						<StyledStep
							className={
								index === 0
									? 'first'
									: index === items.length - 1
									? 'last'
									: ''
							}>
							<div
								className={`step-circle ${
									accomplished ? 'accomplished' : ''
								}`}>
								{index + 1}
							</div>
							<StyledLabel>{title}</StyledLabel>
						</StyledStep>
					)}
				</Step>
			))}
		</ProgressBarComponent>
		{items.map(({ Content }, index) => (
			<StyledContentWrapper
				key={index}
				className={current == index ? '' : 'hide'}>
				<Content nextStep={nextStep} previousStep={previousStep} />
			</StyledContentWrapper>
		))}
	</StyledContainer>
)

const StyledContentWrapper = styled.div`
	margin-top: 100px;

	&.hide {
		display: none;
	}
`

const StyledStep = styled.div`
	position: relative;
	&.first {
		transform: translate(50%);
	}
	&.last {
		transform: translate(-50%);
	}

	.step-circle {
		align-items: center;
		background: white;
		border: 1px solid ${PRIMARY_LIGHT};
		border-radius: 50%;
		color: ${PRIMARY_LIGHT};
		display: flex;
		font-size: 2.7rem;
		height: 50px;
		justify-content: center;
		width: 50px;

		&.accomplished {
			background: ${PRIMARY_LIGHT};
			color: white;
		}
	}
`

const StyledContainer = styled.div`
	margin-top: 45px;

	.RSPBstep {
		top: ${Browser.isInternetExplorer() ? '-20px' : ''};
	}
`

const StyledLabel = styled.span`
	color: ${PRIMARY_LIGHT};
	font-size: 1.8rem;
	left: 50%;
	margin-top: 5px;
	position: absolute;
	text-align: center;
	transform: translate(-50%);
	width: 150%;
`

export default ProgressBar
